import { Controller, useWatch } from 'react-hook-form'

import { TCommonFields } from '../../types'
import { FieldRow, getFieldRules } from '../field-row'
import { useFieldState } from '../hooks'

export type TDateField<T> = TCommonFields<T> & {
    type: 'date' | 'datetime-local' | 'time'
    default?: Date | string
    loadDefault?: () => Promise<Date | string>
}

type TProps<T> = {
    rowField: TDateField<T>
    fieldName: string
    labelWidth?: string
}

const DateTimeField = <T,>({ rowField, fieldName, labelWidth }: TProps<T>) => {
    const { disabled, required } = useFieldState(rowField)
    const value = useWatch({ name: fieldName })

    return (
        <FieldRow
            fieldName={fieldName}
            label={rowField.label}
            required={required}
            labelWidth={labelWidth}
            className="form-date-input"
            filled={!['', undefined, null].includes(value)}
        >
            <Controller
                name={fieldName}
                rules={getFieldRules(rowField, required)}
                render={({ field: { onChange, value, ...rest } }) => (
                    <input
                        {...rest}
                        id={fieldName}
                        value={value ?? ''}
                        onChange={e => {
                            onChange(e)
                            rowField.onChange?.(e.target.value)
                        }}
                        type={rowField.type}
                        required={required}
                        disabled={disabled}
                    />
                )}
            />
        </FieldRow>
    )
}

export default DateTimeField
